import PropTypes from 'prop-types';
export const optionsArray =
    PropTypes.arrayOf(
        PropTypes.shape({
            value: PropTypes.string.isRequired,
            label: PropTypes.string.isRequired
        })
    );